<template>
  <div class="bankmanage">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <!-- <div class="radiobut" v-if="permission.collection_audit">
      <el-radio-group v-model="margintap">
        <el-radio-button label="0">收款管理</el-radio-button>
        <el-badge :value="examinelist" class="examine_length">
          <el-radio-button label="1">审核列表</el-radio-button>
        </el-badge>
      </el-radio-group>
    </div> -->
    <!-- <div class="topcrud" >
      <div class="messagetitle"><span>收款管理</span></div>
    </div> -->

    <!-- 客户经理  v-if="margintap == 0&&authority!=true" :option='option'-->
    <!-- <Paymentmanage
      ref="paymentmanage"
      v-if="margintap == 0 && permission.collection_verifier != true"
      @rowdata="rowdata"
      :showHide="option.column"
      :option="option"
      :files="files"
    /> -->
    <!-- 财务  v-if="margintap == 0&&authority==true" :option='option1' :-->
    <Paymentmanage
      ref="paymentmanage"
     
      :option="option1"
      @rowdata="rowdata"
      @selectionDataItem="selectionDataItem"
      :files="files"
      :conditions="true"
      :showHide="deepClone(option1.column)"
    />
    <!-- <Examinelist ref="examinelist" v-if="margintap == 1" @rowdata="rowdata" :files="files" /> -->
  </div>
</template>

<script>
import * as api from "@/api/zd/collection";
import * as util from "@/util/util";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import Paymentmanage from "./components/collectmanageindex";
import Examinelist from "./components/examinelist";
import { mapGetters } from "vuex";
export default {
  name: "collection",
  data() {
    return {
      margintap: 0,
      examinelist: 0,
      financial: false,
      form: [],
      files: [],
      authority: false,
      option: {
        // selection: true,
        menu:false,
        selectOnIndeterminate: false,
        menuType: "button",
        addBtn: false,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        refreshBtn:false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        menuWidth: 260,
        labelWidth: 100,
        searchShow:false,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "投放名称/项目名称",
            placeholder: "投放名称/项目名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow: true,
          },
          {
            sortable: "custom",
            label: "投放名称",
            prop: "collectTitle",
            width: "180",
            fixed: true,
          },
          {
            label: "款项类型",
            prop: "collectionType",
            width: "80",
            fixed: true,
            type: "select",
            search: true,
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=collection_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            formatter: (row, value, label, column) => {
              return value == -1 ? "" : label;
            },
          },
          {
            label: "收款金额",
            prop: "collectionAmount",
            width: "120",
            formslot: true,
            sortable: "custom",
            formatter: (row, value, label, column) => {
              return this.getMoney(value);
            },
          },
          // {
          //   label: "计划付款日期",
          //   prop: "planDate",
          //   width: "100",
          //   display: false,
          // },
          // {
          //   label: "计划付款日期",
          //   prop: "planDate1",
          //   width: "100",
          //   type: "daterange",
          //    format: "yyyy-MM-dd",
          //   valueFormat: "yyyy-MM-dd",
          //   startPlaceholder: "开始",
          //   endPlaceholder: "结束",
          //   hide: true,
          //   display: true,
          //   hideshow: true,
          // },
          {
            label: "实际收款日期",
            prop: "actualCollectDate",
            width: "100",
            display: false,
          },
          {
            label: "实际收款日期",
            prop: "actualCollectDate1",
            width: "100", 
            type: "daterange",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
            hide: true,
            display: true,
            hideshow: true,
          },
          {
            label: "核销状态",
            prop: "flagVerified",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=flag_verified",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            formatter: (row, value, label, column) => {
              return label;
            },
          },
          {
            label: "记账状态",
            prop: "flagBookkeeping",
            type: "select",

            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=flag_bookkeeping",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            formatter: (row, value, label, column) => {
              return row.flagBookkeeping == 0 ? "-" : label;
            },
          },
          
         
          {
            label: "核算主体",
            prop: "accountingEntity",
            type: "select",
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=accounting_entity",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            width:180
          },
          {
            label: "项目名称",
            prop: "projectName",
            width: "180",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/zd/project/getListDefault",
            dicMethod: "post",
            dicQuery: {
              myself: 1,
            },
            props: {
              label: "name",
              value: "id",
            },
            formatter: (row, value, label, column) => {
              return row.contract.projectName;
            },
          },
          {
            label: "收款人开户行",
            prop: "collectOpeningBank",
            width: "160",
          },

          //  {
          //   label: "对应放款批次",
          //   prop: "loanLot",
          //   type: "select",
          //   dicData: [{ lable: "第一批", key: "第一批" }],
          //   props: {
          //     label: "lable",
          //     value: "key",
          //   },
          //   width:140
          // },

          {
            label: "客户经理",
            prop: "managerName",
            width: "80",
            display: false,
            formatter: (row, value, label, column) => {
              return row.contract.managerName;
            },
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,
            
            search: false,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick("managerUser");
            },
          },
          // {
          //   label: "申请部门",
          //   prop: "deptName",
          //   display:false,
          //   formatter: (row, value, label, column) => {
          //     return row.contract.deptName;
          //   }
          // },

          // {
          //   label: "审批状态",
          //   prop: "wfStatus",
          //   type: "select",
          //   search: true,
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_status",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey"
          //   },
          //   dataType: "number"
          // },
          // {
          //   label: "审核状态",
          //   prop: "auditState",
          //   type: "select",
          //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          //   props: {
          //     label: "dictValue",
          //     value: "dictKey"
          //   },
          //   dataType: "number",
          //   formatter: (row, value, label, column) => {
          //     if (row.wfStatus < 2) {
          //       return "-";
          //     } else {
          //       return label;
          //     }
          //   }
          // },
          

          {
            label: "核销人员",
            prop: "verifierName",
            width: "80",
            readonly: true,
            clearable: false,
            click: () => {
              this.selectPersonClick("verifier");
            },
          },
          {
            label: "核销日期",
            prop: "verificationTime",
            width: "180",
            display: false,
          },
          {
            label: "核销日期",
            prop: "verificationTime1",
            width: "180",
            type: "daterange",
            format: "yyyy-MM-dd",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
            hide: true,
            display: true,
            hideshow: true,
          },
        ],
      },
      option1SelectableData: {},
      //财务
      option1: {
        menu:false,
        searchShow:false,
        selection: true,
        selectOnIndeterminate: false,
        selectable: (row, index) => {
          return this.option1SelectableData.id
            ? this.option1SelectableData.id == row.id
              ? true
              : false
            : true;
        },
        reserveSelection: true,
        multiple: false,
        menuType: "button",
        addBtn: false,
        menuWidth: 180,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        refreshBtn:false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        labelWidth: 100,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "投放名称/项目名称",
            placeholder: "投放名称/项目名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow: true,
          },
          {
            sortable: "custom",
            label: "投放名称",
            prop: "collectTitle",
            slot:true,
            width: "180",
            display: false,
            fixed: true,
          },
          {
            label: "款项类型",
            prop: "collectionType",
            width: "80",
            fixed: true,
            type: "select",
            search: true,
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=collection_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            formatter: (row, value, label, column) => {
              return value == -1 ? "" : label;
            },
            dataType: "number",
          },
          {
            label: "核销状态",
            prop: "flagVerified",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=flag_verified",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
          },
          {
            label: "记账状态",
            prop: "flagBookkeeping",
            type: "select",

            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=flag_bookkeeping",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            formatter: (row, value, label, column) => {
              return row.flagBookkeeping == 0 ? "-" : label;
            },
          },
          {
            label: "收款金额",
            prop: "collectionAmount",
            width: "120",
            formslot: true,
            sortable: "custom",
            formatter: (row, value, label, column) => {
              return this.getMoney(value);
            },
          },
          {
            label: "实际收款日期",
            prop: "actualCollectDate",
            width: "100",
            display: false,
          },
          {
            label: "实际收款日期",
            prop: "actualCollectDate1",
            width: "100",
            format: "yyyy-MM-dd",
            type: "daterange",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
            hide: true,
            display: true,
            hideshow: true,
          },
          
          {
            label: "核算主体",
            prop: "accountingEntity",
            type: "select",
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=accounting_entity",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            width:180
          },
          {
            label: "项目名称",
            prop: "projectName",
            type: "select",
            filterable:'true' ,
            width: "180",
            dicUrl: "/api/zd/project/getListDefault",
            dicMethod: "post",
            dicQuery: {
              // myself:1
            },
            props: {
              label: "name",
              value: "id",
            },
            formatter: (row, value, label, column) => {
              return row.contract.projectName;
            },
          },
          {
            label: "收款人开户行",
            prop: "collectOpeningBank",
            width: "160",
          },
          // {
          //   label: "对应放款批次",
          //   prop: "loanLot",
          //   type: "select",
          //   dicData: [{ lable: "第一批", key: "第一批" }],
          //   props: {
          //     label: "lable",
          //     value: "key",
          //   },
          //   width:140
          // },
          {
            label: "客户经理",
            prop: "managerName",
            width: "80",
            display: false,
            // type: "tree",
            // dicUrl: "/api/blade-/zd/custom/users",
            // dicMethod: "post",
            // dicQuery: {
            //   type: 0,
            // },
            // props: {
            //   label: "realName",
            //   value: "id",
            // },
            // dataType: "string",
            formatter: (row, value, label, column) => {
              return row.contract.managerName;
            },
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,
            width: "80",

            search: false,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick("managerUser");
            },
          },
          {
            label: "申请部门",
            prop: "deptName",
                width:200,
            display: false,
            formatter: (row, value, label, column) => {
              return row.contract.deptName;
            },
          },

          {
            label: "核销人员",
            prop: "verifierName"   ,
            width: "80",
            readonly: true,
            clearable: false,
            click: () => {
              this.selectPersonClick("verifier");
            },
            // contactPhone
          },

          {
            label: "核销日期",
            prop: "verificationTime",
            width: "180",
            display: false,
          },
          {
            label: "核销日期",
            prop: "verificationTime1",
            width: "180",
            type: "daterange",
            format: "yyyy-MM-dd",
            startPlaceholder: "开始",
            endPlaceholder: "结束",
            hide: true,
            display: true,
            hideshow: true,
          },
        ],
      },
    };
  },
  components: {
    TagsCloud,
    Paymentmanage,
    Examinelist,
  },
  created() {
    this.onload();
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  methods: {
    selectionDataItem(val) {
      if (val.length <= 0) {
        this.option1SelectableData = {};
      } else {
        this.option1SelectableData = val[0];
      }
    },
    onload() {
      api
        .collectiongetgetList({
          firstNum: 0,
          num: 10,
        })
        .then((res) => {
           
          this.examinelist = res.data.data.shlb;
          this.authority = res.data.data.hasAuditRight;
          this.financial = res.data.data.financial;
        })
        .catch((res) => {
           
        });
    },

    rowdata(data) {
      this.$refs.cloudtage.save(data);
    },

    cloudTages(data) {
      this.files = data;
     
    },
    // 人员选择插件打开
    selectPersonClick(name) {
      this.$refs.paymentmanage.selectPersonClick(name);
    },
  },
};
</script>
<style lang="scss" scoped>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      // font-weight: bolder;
    }
  }
  .radiobut {
    margin: 25px 0;
  }
  /deep/ .el-range-separator {
    width: 20px !important;
  }
}
</style>
